var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex my-3"},[_c('div',{staticClass:"text-h4 font-bold"},[_vm._t("default")],2),(_vm.hasHelpContent)?_c('div',{staticClass:"ml-1"},[_c('help-dialog',{ref:"helpDialog",attrs:{"data":_vm.helpInfo}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }